import { render, staticRenderFns } from "./VideoTextInput.vue?vue&type=template&id=5ce31510"
import script from "./VideoTextInput.vue?vue&type=script&lang=ts"
export * from "./VideoTextInput.vue?vue&type=script&lang=ts"
import style0 from "./VideoTextInput.vue?vue&type=style&index=0&id=5ce31510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports